import React, { useState, useEffect } from "react";
import api from "../../api";
import {
  Grid,
  Select,
  FormControl,
  CardContent,
  MenuItem,
  InputLabel,
  Paper,
  Typography,
  Card,
  ButtonGroup,
  Divider,
  TextField,
} from "@material-ui/core";
import SwitchSelector from "react-switch-selector";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import { useSelector } from "react-redux";
import Lms from "./GlLms.js";
import Hvac from "./Devicemap";
import { message, Spin } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import engine from "../../assets/img/engine-fan.png";
import ventilator from "../../assets/img/Ventilators.png";
import CSU from "../../assets/Images/CSU.png";
import FAU from "../../assets/img/FAU_icon.png";
import AHUSummaryPage from "./../AHU/GlAhuSummaryPage";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
  formControl: {
    autosize: true,
    clearable: false,
  },
  floorcard: {
    width: "26%",
    height: "6vh",
    marginLeft: "2vh",
  },
  // selector:{
  //     overflow:'hidden',
  //     width: "42%",
  //     // borderRadius:'0.8vw'(hvac&LMS)
  //     marginLeft:'2vh'
  // },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  style: {
    overflow: "hidden",
    boxShadow: "inset 0 3px 8px rgba(0, 0, 0, .3)",
  },
  select: {
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      //xl
      fontSize: "2vh",
      // marginTop: "-1vh",
    },
    "&:after": {
      borderBottomColor: "blue",
      marginTop: "-2vh",
      "@media (min-width:1920px) and (max-width:2559.95px)": {
        //xl
        fontSize: "2vh",
        marginTop: "-1vh",
      },
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
    "& .MuiSelect-root": {
      marginTop: "-2vh",
    },
    //   "& .MuiSelect-select"
  },
}));

export default function Selector(props) {
  let zones = [],
    newZones = [],
    occupancy = [];
  const [fdata, setFdata] = React.useState(localStorage.getItem("floorName"));
  const [fid, setFId] = React.useState("");
  const [floor, setFloor] = useState([]);
  const [value, setValue] = React.useState("");
  const [view, setView] = React.useState(false);
  const [boolfloor, setboolfloor] = React.useState(true);
  const [boolzone, setboolzone] = React.useState(false);
  const [boolarea, setboolarea] = React.useState(false);
  const [locationId, setLocation] = React.useState("");
  const [zone_tag, setZone_Tag] = React.useState("");
  const [zone, setZone] = useState([]);
  const [dropfloor, setDropfloor] = useState([]);
  const [data, setData] = React.useState(false);
  const [level, setLevel] = React.useState("plan_view");
  const [loading, setLoading] = useState(false);
  const buildingID = useSelector((state) => state.isLogged.data.building.id);
  // const campusId = useSelector(state =>state.isLogged.data.campus.id)
  const classes = useStyles();
  useEffect(() => {
    api.dashboard.getMetricData(buildingID).then((res) => {
      res.sort(function (a, b) {
        return a.zone_tag > b.zone_tag ? 1 : b.zone_tag > a.zone_tag ? -1 : 0;
      });
      setFloor(res);

      if (res.length > 0) {
        const firstFloor = res[0];
        setFdata(firstFloor.name);
        setFId(firstFloor.id);
        setZone_Tag(firstFloor.zone_tag);
        setLocation(firstFloor.id);

        localStorage.setItem("floorName", firstFloor.name);
        localStorage.setItem("floorID", firstFloor.id);
        localStorage.setItem("zone_tag", firstFloor.zone_tag);
      }
    });

    // Other logic...
    setboolarea(false);
    setboolfloor(true);
    setboolzone(false);
    setView(false);
  }, [view]);

  const handlefloorchange = (name, id, zone_tag) => {
    let type = "tfa";
    if (level == "plan_view") {
      props.history.push({
        // pathname: `/admin/selector`,
        state: {
          data: id,
          fname: name,
          param: type,
        },
      });
    }
    setFId(id);
    setFdata(name);
    setZone_Tag(zone_tag);
    localStorage.setItem("floorName", name);
    localStorage.setItem("floorID", id);
    localStorage.setItem("zone_tag", zone_tag);
    setFdata(name);
    setData(false);
    localStorage.setItem("floorName", name);
  };
  const onChange = (newValue) => {
    localStorage.setItem("type", newValue);
    setLevel(newValue);
    if (newValue === "summary_view") {
      setLoading(true);
      // localStorage.setItem("deviceID", value.id);
      // localStorage.setItem("deviceName", value.name);
      setView(true);
      // setLocation(localStorage.getItem('floorID'))
      // setFdata(localStorage.getItem('floorName'))
      // setZone_Tag(localStorage.getItem('zone_tag'))
      // setboolarea(false)
      // setboolfloor(true)
      // setboolzone(false)
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    } else {
      setLoading(true);
      setView(false);
      setData(false);
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    }
  };
  const options = [
    {
      label: "Plan View",
      value: "plan_view",
      selectedBackgroundColor: "#0123b4",
    },
    {
      label: "Summary View",
      value: "summary_view",
      selectedBackgroundColor: "#0123b4",
    },
  ];
  const initialSelectedIndex = options.findIndex(
    ({ value }) => value === "plan_view"
  );
  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid container item xs={12} spacing={1}>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
            <FormControl
              variant="filled"
              size="large"
              className={classes.formControl}
              style={{
                width: "max-content",
                minWidth: "100%",
                backgroundColor: "#eeeef5",
                fontFamily: "Arial",
                height: "6vh", // Ensuring the same height
              }}
            >
              {view === true ? (
                <Select
                  labelId="filled-hidden-label-small"
                  id="demo-simple-select-outlined"
                  label="Floor"
                  value="All Floors"
                  style={{
                    fontWeight: "bold",
                    height: "6vh",
                    borderRadius: "0.8vw",
                    fontFamily: "Arial",
                    pointerEvents: "none",
                    opacity: "0.4",
                  }}
                  disableUnderline
                  className={classes.select}
                >
                  <MenuItem key="All Floors" value="All Floors">
                    All Floors
                  </MenuItem>
                </Select>
              ) : (
                <Select
                  labelId="filled-hidden-label-small"
                  id="demo-simple-select-outlined"
                  label="Floor"
                  value={fdata || ""}
                  style={{
                    fontWeight: "bold",
                    height: "6vh",
                    borderRadius: "0.8vw",
                    fontFamily: "Arial",
                  }}
                  disableUnderline
                  className={classes.select}
                >
                  {floor.map((_item) => (
                    <MenuItem
                      key={_item.name}
                      value={_item.name}
                      onClick={() =>
                        handlefloorchange(_item.name, _item.id, _item.zone_tag)
                      }
                    >
                      {_item.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
            <div className={classes.selector} style={{ height: "6vh" }}>
              <SwitchSelector
                onChange={onChange}
                options={options}
                initialSelectedIndex={initialSelectedIndex}
                wrapperBorderRadius={5}
                optionBorderRadius={8}
              />
            </div>
          </Grid>
          {view === true ? (
            <></>
          ) : (
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
              <Card
                style={{
                  width: "50%",
                  minWidth: "50px",
                  backgroundColor: "#f9f9f9",
                  height: "6vh",
                }}
              >
                <CardContent
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    padding: 0,
                    marginTop: "1vh",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "15px",
                    }}
                  >
                    <img
                      src={engine}
                      alt="Engine Fan"
                      style={{
                        width: "24px",
                        height: "24px",
                        marginRight: "5px",
                      }}
                    />
                    <Typography
                      variant="body2"
                      style={{
                        fontWeight: "bold",
                        marginRight: "10px",
                        fontSize: window.innerHeight == "1080" ? "2vh" : "",
                      }}
                    >
                      Treated Fresh Air
                    </Typography>
                  </div>

                  {/* <div style={{ display: 'flex', alignItems: 'center', marginRight: '15px' }}>
                  <img src={ventilator} alt="Ventilator" style={{ width: '24px', height: '24px', marginRight: '5px' }} />
                  <Typography variant="body2" style={{ fontWeight: 'bold', marginRight: '5px' }}>Ventilator</Typography>
                </div> */}
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      </Grid>
      {view === true || data === true ? (
        <div>
          <AHUSummaryPage />
        </div>
      ) : (
        // <Spin spinning={loading} size="default" style={{ justifyContent: 'center', alignContent: 'center', position: 'fixed' }}>
        //   <Lms location={locationId} fdata={fdata} zone={zone} dropfloor={zone} />
        // </Spin>
        <Spin
          spinning={loading}
          size="default"
          style={{
            justifyContent: "center",
            alignContent: "center",
            position: "fixed",
          }}
        >
          <Hvac data={props} zone_tag={zone_tag} />
        </Spin>
      )}
      {loading === true ? (
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <div></div>
      )}
    </div>
  );
}
